import { Box, Paper, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material"
import React, { useEffect } from "react";
import CustomTabPanel from "../components/CustomTabPanel";
import { CAP, CashFlowClassification, CashFlowMapping, GTBClassification, SocialAccountMapping } from "../helpers/interfaces";
import { getAllCAP, getAllCashFlowClassification, getAllCashFlowMappings, getAllGTBClassification, getAllSocialAccountMapping } from "../apiServices/GTBMappingKeysApi";
import SocialAccountMappingList from "../components/gtbMapping/socialAccountMapping/SocialAccountMappingList";
import GTBClassificationList from "../components/gtbMapping/gtbClassification/GTBClassification";
import CashFlowMappingList from "../components/gtbMapping/cashFlowMapping/CashFlowMappingList";
import CashFlowClassificationList from "../components/gtbMapping/cashFlowCkassification/CashFlowClassificationList";
import CAPList from "../components/gtbMapping/cap/CAPList";

function GTBMappingKeys() {
    const theme = useTheme();
    const [selectedTabValue, setSelectedTabValue] = React.useState(1);
    const [cashFlowClassification, setCashFlowClassification] = React.useState<CashFlowClassification[]>([])
    const [cashFlowMapping, setCashFlowMapping] = React.useState<CashFlowMapping[]>([])
    const [socialAccountMapping, setSocialAccountMapping] = React.useState<SocialAccountMapping[]>([])
    const [gtbClassification, setGtbClassification] = React.useState<GTBClassification[]>([])
    const [cap, setCAP] = React.useState<CAP[]>([])
    useEffect(() => {
        getAllCashFlowClassification().then(cfc => setCashFlowClassification(cfc))
        getAllCashFlowMappings().then(cfm => setCashFlowMapping(cfm))
        getAllGTBClassification().then(gtb => setGtbClassification(gtb))
        getAllSocialAccountMapping().then(sam => setSocialAccountMapping(sam))
        getAllCAP().then(cap => setCAP(cap))
    }, [])

    return (
        <>
            <Box m="1.0rem 1.0rem">
                <Stack>
                    <Paper>
                        <Typography fontWeight="bold" sx={{ margin: '1.0rem', color: theme.palette.secondary.main, fontSize: '13px' }}>
                            GTB Mapping keys
                        </Typography>
                    </Paper >
                </Stack>
                <Box>
                    <br />
                    <Paper>
                        <Box mt="10px" p='1.0rem' gap="20px">
                            <div>
                                <Tabs
                                    variant="fullWidth" value={selectedTabValue} onChange={(event: any, newValue: any) => setSelectedTabValue(Number(newValue))} textColor="secondary"
                                    indicatorColor="secondary" sx={{ fontWeight: 500 }}
                                    aria-label="secondary tabs example">
                                    <Tab label=" Social Account Mapping" value={1} />
                                    <Tab label="Classification" value={2} />
                                    <Tab label="Cash Flow Mapping" value={3} />
                                    <Tab label="Cash Flow Classification" value={4} />
                                    <Tab label="CAP" value={5} />
                                </Tabs>
                            </div>
                            <CustomTabPanel value={selectedTabValue} index={1} >
                                <div >
                                    <SocialAccountMappingList socialAccountMapping={socialAccountMapping} setSocialAccountMapping={setSocialAccountMapping} />
                                </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={2} >
                                <div >
                                    <GTBClassificationList setGTBClassification={setGtbClassification} gtbClassification={gtbClassification} />
                                </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={3} >
                                <div >
                                    <CashFlowMappingList setCashFlowMapping={setCashFlowMapping} cashFlowMapping={cashFlowMapping} />
                                </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={4} >
                                <div >
                                    <CashFlowClassificationList cashFlowClassification={cashFlowClassification} setCashFlowClassification={setCashFlowClassification} />
                                </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={5} >
                                <div >
                                    <CAPList cap={cap} setCAP={setCAP} />
                                </div>
                            </CustomTabPanel>

                        </Box>
                    </Paper>
                </Box>
            </Box>

        </>
    )
}
export default GTBMappingKeys;